var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("receivablePayable.GenerateBillsPayable"),
        width: "600px",
        top: "10vh",
        "append-to-body": true,
        visible: _vm.isShow,
        "close-on-press-escape": false,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.submitLoading,
              expression: "submitLoading",
            },
          ],
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            size: "small",
            "label-width": "100px",
            "label-position": "top",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("receivablePayable.SelectBillingDate"),
                prop: "TimeCollection",
              },
            },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  type: "daterange",
                  "range-separator": "-",
                  "start-placeholder": _vm.$t("operationCenter.startDate"),
                  "end-placeholder": _vm.$t("operationCenter.endDate"),
                  "value-format": "yyyy-MM-dd",
                },
                model: {
                  value: _vm.ruleForm.TimeCollection,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "TimeCollection", $$v)
                  },
                  expression: "ruleForm.TimeCollection",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("collectionCenter.TypeBill"),
                prop: "payableType",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                    disabled: true,
                  },
                  model: {
                    value: _vm.ruleForm.payableType,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "payableType", $$v)
                    },
                    expression: "ruleForm.payableType",
                  },
                },
                _vm._l(_vm.PAYABLE_TYPE, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.payableType === 4 || _vm.payableType === 7
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("basicData.ExpenseType"),
                    prop: "feeCodeList",
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "error-table",
                      attrs: {
                        data: _vm.ruleForm.feeCodeList,
                        border: "",
                        size: "mini",
                        "max-height": "200",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("GlobalSetObj.serial"),
                          width: "50",
                          type: "index",
                        },
                      }),
                      _c(
                        "el-table-column",
                        {
                          attrs: { label: _vm.$t("basicData.ExpenseType") },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "formStyle" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "feeCodeList." +
                                                scope.$index +
                                                ".feeCode",
                                              rules: {
                                                required: true,
                                                message: _vm.$t(
                                                  "basicData.CannotBeEmpty"
                                                ),
                                                trigger: ["blur", "change"],
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  filterable: "",
                                                  clearable: "",
                                                  multiple: "",
                                                  placeholder: _vm.$t(
                                                    "operationCenter.PleaseSelect"
                                                  ),
                                                  "popper-class": "top-select",
                                                },
                                                on: {
                                                  change: _vm.feeTypeChange,
                                                },
                                                model: {
                                                  value: scope.row.feeCode,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "feeCode",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.feeCode",
                                                },
                                              },
                                              _vm._l(
                                                _vm.feeList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.displayName,
                                                      value: item.code,
                                                      disabled:
                                                        _vm.isOptionDisabled(
                                                          scope.$index,
                                                          item.code
                                                        ),
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4037714263
                          ),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#f00",
                                    "margin-right": "5px",
                                  },
                                },
                                [_vm._v("*")]
                              ),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("basicData.ExpenseType"))),
                              ]),
                            ]),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: { width: "100", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-popconfirm",
                                      {
                                        attrs: {
                                          title: _vm.$t(
                                            "basicData.AreYouSureDelete"
                                          ),
                                        },
                                        on: {
                                          confirm: function ($event) {
                                            return _vm.deleteCost(scope)
                                          },
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "el-icon-delete deleteStyle",
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1374627915
                          ),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", {
                              staticClass: "el-icon-plus addStyle",
                              on: { click: _vm.addCost },
                            }),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.payableType === 5
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("basicData.PayablePrincipal") } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.ruleForm.providerId,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "providerId", $$v)
                          },
                          expression: "ruleForm.providerId",
                        },
                      },
                      _vm._l(_vm.providerData, function (item) {
                        return _c("el-option", {
                          key: item.providerId,
                          attrs: {
                            label: item.name + "（" + item.code + "）",
                            value: item.providerId,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("basicData.transportType") } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.ruleForm.routeType,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "routeType", $$v)
                          },
                          expression: "ruleForm.routeType",
                        },
                      },
                      _vm._l(_vm.TRANSPORTATION_TYPE, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer footer-tips-all",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "footer-tips-all", staticStyle: { flex: "1" } },
            [
              _c("div", { staticClass: "tips-icon" }, [_vm._v("!")]),
              _c("div", { staticClass: "tips-text" }, [
                _c("div", [
                  _vm._v(
                    "1：" +
                      _vm._s(
                        _vm.$t(
                          "receivablePayable.UncheckedDataWillGenerateAccountsPayableForAllQueriedDataConfirmToGenerateAccountsPayable"
                        )
                      )
                  ),
                ]),
                [1, 2, 6, 7].includes(_vm.payableType)
                  ? _c("div", [
                      _vm._v(
                        "2：" +
                          _vm._s(
                            _vm.$t(
                              "receivablePayable.TheNumberOfBranchesCannotExceed10"
                            )
                          )
                      ),
                    ])
                  : _vm._e(),
                [3].includes(_vm.payableType)
                  ? _c("div", [
                      _vm._v(
                        "2：" +
                          _vm._s(
                            _vm.$t(
                              "receivablePayable.TheCombinationOfStationsAndDriversCannotExceed30AtMost"
                            )
                          )
                      ),
                    ])
                  : _vm._e(),
                [4].includes(_vm.payableType)
                  ? _c("div", [
                      _vm._v(
                        "2：" +
                          _vm._s(
                            _vm.$t(
                              "receivablePayable.TheNumberOfBranchesCannotExceed5"
                            )
                          )
                      ),
                    ])
                  : _vm._e(),
                [5].includes(_vm.payableType)
                  ? _c("div", [
                      _vm._v(
                        "2：" +
                          _vm._s(
                            _vm.$t(
                              "receivablePayable.TheMaximumNumberOfPayableEntitiesCannotExceed10"
                            )
                          )
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
          _c(
            "div",
            { staticStyle: { width: "200px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", disabled: _vm.submitLoading },
                  on: { click: _vm.onClose },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.submitLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }